import { memo, forwardRef, MutableRefObject } from 'react';
import {
   ChakraSVGCircle,
   ChakraSVGGroup,
   ChakraSVGCircleProps,
   ChakraSVGGroupProps,
} from './styleableSvgComponents';

// Forwarded for tippy:
// https://github.com/atomiks/tippy.js-react#component-children
export const BasicHotspot = memo(
   forwardRef(
      // @ts-expect-error TS(2345) FIXME: Argument of type '({ x, y, innerCircleProps, outer... Remove this comment to see the full error message
      (
         {
            x,
            y,
            innerCircleProps,
            outerCircleProps,
            groupProps,
         }: {
            x: number;
            y: number;
            innerCircleProps?: ChakraSVGCircleProps;
            outerCircleProps?: ChakraSVGCircleProps;
            groupProps?: ChakraSVGGroupProps;
         },
         ref: MutableRefObject<SVGGElement>
      ) => (
         <ChakraSVGGroup ref={ref} {...groupProps}>
            <ChakraSVGCircle x={x} y={y} r={18} {...outerCircleProps} />
            <ChakraSVGCircle x={x} y={y} r={6} {...innerCircleProps} />
         </ChakraSVGGroup>
      )
   )
);
